'use client';

import { useEffect } from 'react';
import { RegistrationStatus } from '@/types/pam-api';
import { sendLoginEvent, sendSignupEvent } from '@/features/analytics/datalayer/datalayer';
import { useUserToken } from '@/features/user-token-provider/use-user-token';
import { Webengage } from '@/features/webengage';
import { Binoban } from '@/utils/binoban';
import useUser from '@/utils/use-user';
import { IS_SET_USER_ATTRIBUTE_STORAGE_KEY } from './constants';
import { StorageKey } from './header/components/types';
import { useWebengageDataProvider } from './header/utils/webengage-data-provider';
const UserEventsTracker = () => {
  const {
    user,
    isLoggedIn
  } = useUser();
  const {
    prevPath,
    pageTitle,
    pathname
  } = useWebengageDataProvider();
  const {
    userToken,
    setUserToken
  } = useUserToken();
  const registrationStatus = user?.registrationStatus;
  const userId = user?.id;
  useEffect(() => {
    if (!isLoggedIn || !userId || !registrationStatus) return;
    const isNewUser = registrationStatus === RegistrationStatus.NewUser;
    Webengage.identify(userId);
    if (isNewUser) {
      Webengage.signup();
      sendSignupEvent();
    } else {
      sendLoginEvent();
    }
  }, [isLoggedIn, registrationStatus, userId]);
  useEffect(() => {
    if (!user) return;
    const hasVisited = sessionStorage.getItem(StorageKey.HasSetAttributes);
    if (hasVisited === 'true') return;
    Webengage.setUserAttributes(user);
    sessionStorage.setItem(StorageKey.HasSetAttributes, 'true');
  }, [user]);
  useEffect(() => {
    user?.id && setUserToken(user.id);
  }, [user?.id, setUserToken]);
  useEffect(() => {
    if (!!user?.id || user?.id === userToken || !userToken) return;
    Binoban.setAnonymousId(userToken);
  }, [userToken, user?.id]);
  useEffect(() => {
    if (isLoggedIn && sessionStorage.getItem(IS_SET_USER_ATTRIBUTE_STORAGE_KEY) !== 'set' && user?.id) {
      Binoban.identify(user.id);
    }
  }, [isLoggedIn, user, user?.id]);
  useEffect(() => {
    if (pageTitle === null) return;
    Webengage.trackPageView({
      pathname,
      pageTitle,
      prevPath
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevPath]);
  return null;
};
export default UserEventsTracker;